/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Sleep om het paneel te vergroten',
  command_intelligence_close_aria: 'Assistent sluiten',
  command_intelligence_send_aria: 'Bericht verzenden',
  command_intelligence_stop_aria: 'Antwoord stoppen',
  command_intelligence_composer_input_aria: 'Bericht aan Command Intelligence',
  command_intelligence_drawer_more_options: 'Meer opties',
  command_intelligence_dock_position: 'Dockepositie',
  command_intelligence_dock_left: 'Links',
  command_intelligence_dock_right: 'Rechts',
  command_intelligence_dock_top: 'Boven',
  command_intelligence_dock_bottom: 'Onder',
  command_intelligence_panel_layout: 'Paneelindeling',
  command_intelligence_panel_layout_overlap: 'Inhoud overlappen',
  command_intelligence_panel_layout_push: 'Inhoud duwen',
  command_intelligence_panel_auto_hide_overlap: 'Automatisch verbergen bij klikken buiten',
  command_intelligence_session_reset: 'Gesprek resetten',
  command_intelligence_try_one_of_these: 'Probeer een van deze',
  command_intelligence_attach_hint: 'Voeg contextitems toe om vragen te stellen.',
  command_intelligence_attach_modal_title: 'Context toevoegen',
  command_intelligence_attach_modal_subtitle: 'Kies uit items in deze weergave. Reeds toegevoegde items zijn grijs.',
  command_intelligence_attach_modal_search_placeholder: 'Zoeken…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# item beschikbaar} other {# items beschikbaar}} · {selected} geselecteerd',
  command_intelligence_attach_modal_empty: 'Niets beschikbaar om toe te voegen',
  command_intelligence_attach_modal_no_results: 'Geen items komen overeen met uw zoekopdracht',
  command_intelligence_context_bar_attached_section: 'Toegevoegd ({count})',
  command_intelligence_context_bar_clear_attached: 'Wissen',
  command_intelligence_context_bar_add: 'Context toevoegen',
  command_intelligence_placeholder_ready: 'Stel een vraag…',
  command_intelligence_placeholder_attach: 'Voeg context toe om een vraag te stellen…',
  command_intelligence_composer_submit_hint: 'Enter om te verzenden · Shift+Enter voor nieuwe regel',
  command_intelligence_composer_stop_hint: 'Stoppen · concept voor volgend bericht tijdens het wachten',
  command_intelligence_response_stopped: 'Antwoord gestopt',
  command_intelligence_generation_in_progress: 'Uw vraag wordt verwerkt',
  command_intelligence_generation_trace_title: 'Uitgevoerde stappen',
  command_intelligence_generation_trace_toggle: 'Stappen tonen',
  command_intelligence_generation_trace_summary: '{completed} van {total} stappen voltooid',
  command_intelligence_generation_trace_summary_generic: 'Generatiestappen',
  command_intelligence_generation_tool_count: '{count, plural, one {# tool} other {# tools}}',
  command_intelligence_generation_turn_label: 'Beurt {turn} van {total}',
  command_intelligence_generation_turn_completed: 'Beurt {turn} van {total} voltooid',
  command_intelligence_generation_turn_completed_elapsed: 'Beurt {turn} van {total} voltooid ({seconds}s verstreken)',
  command_intelligence_generation_turn_completed_with_tools: 'Beurt {turn} van {total} voltooid – {tools} gebruikt',
  command_intelligence_generation_tools_used: '{tools} gebruikt',
  command_intelligence_reasoning_thinking: 'Denken…',
  command_intelligence_reasoning_thought_for_seconds: '{seconds} seconden nagedacht',
  command_intelligence_reasoning_waiting: 'Uw vraag wordt verwerkt…',
  command_intelligence_attach_modal_done: 'Gereed',
  command_intelligence_attach_modal_attached_badge: 'toegevoegd',
  command_intelligence_attach_modal_attach: 'Toevoegen',
  command_intelligence_attach_modal_attach_count: 'Toevoegen ({count})',
  command_intelligence_attach_modal_close_aria: 'Kiezer sluiten',
  command_intelligence_session_limit_context: 'Contextlimiet bereikt. Reset het gesprek om door te gaan.',
  command_intelligence_session_limit_prompt: 'Berichtlimiet bereikt. Reset het gesprek om door te gaan.',
  command_intelligence_suggested_followups: 'Voorgestelde vervolgvragen',
  command_intelligence_credit_warning_line: '{pct}% van maandelijkse AI-tegoeden voor {scope} gebruikt',
  command_intelligence_tooltip_prompts: '{count} van {max} berichten ({pct}%)',
  command_intelligence_tooltip_context: '{used} van {max} contexttokens ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Contextgebruik verschijnt na het eerste antwoord',
  command_intelligence_credits_loading: 'Tegoeden laden…',
  command_intelligence_credits_unavailable: 'Tegoeden niet beschikbaar',
  command_intelligence_credits_tooltip: 'Maandelijkse AI-tegoeden voor {monthKey}',
  command_intelligence_credits_tooltip_short: 'Maandelijkse AI-tegoeden',
  command_intelligence_credits_scope_profile: 'Profiel',
  command_intelligence_credits_scope_entity: 'Entiteit',
  command_intelligence_credits_used_of_cap: '{used} van {cap} tegoeden',
  command_intelligence_credits_used_no_cap: '{used} tegoeden gebruikt',
  command_intelligence_credits_monthly_title: 'Maandelijkse AI-tegoeden',
  command_intelligence_compare_aria: 'Agenten vergelijken',
  command_intelligence_compare_tooltip: 'Dezelfde vraag uitvoeren met meerdere agentprofielen',
  command_intelligence_compare_cancelled: 'Vergelijking geannuleerd',
  command_intelligence_compare_branch_failed: 'Vergelijkingsvertakking mislukt',
  command_intelligence_compare_title: 'Agentvergelijking',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} in / {outTok} uit · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Goed antwoord',
  command_intelligence_feedback_bad_response: 'Slecht antwoord',
  command_intelligence_feedback_dialog_title: 'Feedback geven',
  command_intelligence_feedback_dialog_body:
    'Help ons verbeteren door feedback te geven op dit antwoord. Uw feedback wordt naar ons operationele team gestuurd.',
  command_intelligence_feedback_response_label: 'Antwoord',
  command_intelligence_feedback_input_label: 'Uw feedback (optioneel)',
  command_intelligence_feedback_input_placeholder: 'Wat was er mis of onbehulpzaam aan dit antwoord?',
  command_intelligence_feedback_submit: 'Feedback verzenden',
  command_intelligence_feedback_submit_error: 'Feedback verzenden mislukt. Probeer het opnieuw.',
  command_intelligence_feedback_question_understanding: 'Begreep de agent wat u wilde?',
  command_intelligence_feedback_question_readability: 'Was het antwoord gemakkelijk te lezen en te gebruiken?',
  command_intelligence_feedback_section_understanding: 'Begrip',
  command_intelligence_feedback_section_readability: 'Leesbaarheid',
  command_intelligence_feedback_choice_none: 'Geen',
  command_intelligence_feedback_choice_misunderstood_task: 'Taak verkeerd begrepen',
  command_intelligence_feedback_choice_ignored_constraint: 'Beperking genegeerd',
  command_intelligence_feedback_choice_wrong_scope: 'Verkeerde scope',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visueel moeilijk leesbaar',
  command_intelligence_feedback_choice_wrote_too_much: 'Te veel geschreven',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Uitleg niet betrouwbaar',
  command_intelligence_copy_aria: 'Kopiëren naar klembord',
  command_intelligence_error_missing_invoke_permission:
    'U hebt geen toestemming om Command Intelligence voor deze agent te gebruiken. Vraag uw beheerder om de vereiste Intelligence-machtigingen toe te kennen (bijvoorbeeld analyst).',
  command_intelligence_access_denied_title: 'Toegang vereist',
  command_intelligence_error_session_expired: 'Uw sessie is verlopen. Vernieuw de pagina en meld u opnieuw aan.',
};
